// This cookie name is used to store the access token in the browser cookies
const accessTokenCookieName = `plej-cms-access-token-${process.env.REACT_APP_ENVIRONMENT}`

// This name is used to store the dark mode state in local storage
const darkModeStateName = 'plej-cms-dark-mode'

// This name is used to store user data in local storage
const userDataName = `plej-cms-user-data-${process.env.REACT_APP_ENVIRONMENT}`

// This name is used to store the state of the sidebar in local storage
const sidebarStateName = 'plej-cms-sidebar-open'

// This name is used to store the state default show per page vlaue
const showPerPageName = 'plej-cms-show-per-page'

export { accessTokenCookieName, darkModeStateName, userDataName, sidebarStateName, showPerPageName }
